import { createContext } from "react";

export const LanguageContext = createContext<LanguageType>("ko");
export const LoginContext = createContext<string | null>(null);
export const ModalDismissContext = createContext<(() => void) | null>(null);
